import styled from '@emotion/styled';
import PerfectScrollbar from 'react-perfect-scrollbar';

import Typography from '../../atoms/typography';

export const Heading = styled(Typography)(({ theme }) => ({
  color: theme.color.white,
  borderBottom: `1px solid ${theme.color.brand}`,
  display: 'flex',
  letterSpacing: '0.2rem',
  lineHeight: '4rem',
  textTransform: 'uppercase',
  '> span': {
    color: theme.color.brandLight,
    letterSpacing: 'initial',
    marginLeft: 'auto',
    textTransform: 'none'
  },
  [`@media screen and (min-width: ${theme.breakpoint.medium})`]: {
    color: theme.color.brand
  }
}));

export const Accordion = styled.section(({ theme }) => ({
  borderBottomWidth: 1,
  borderStyle: 'solid',
  borderColor: theme.color.white,
  [`@media screen and (min-width: ${theme.breakpoint.medium})`]: {
    borderColor: theme.color.brand
  }
}));

export const AccordionTrigger = styled.button`
  appearance: none;
  ${(props) => props.theme.arrow(props.active ? 'up' : 'down', props.theme.color.white, 'right 1px center', 4)}
  background-color: transparent;
  border: 0 none;
  color: ${(props) => props.theme.color.white};
  cursor: pointer;
  display: block;
  font-family: ${(props) => props.theme.font.sans};
  font-size: ${(props) => props.theme.modularScale.small};
  line-height: 4rem;
  outline: none;
  padding: 0;
  position: relative;
  text-align: left;
  text-transform: capitalize;
  width: 100%;

  @media screen and (min-width: ${(props) => props.theme.breakpoint.medium}) {
    ${(props) => props.theme.arrow(props.isOpened ? 'up' : 'down', props.theme.color.brand, 'right 1px center', 4)}
    color: ${(props) => props.theme.color.brand};
  }
`;

export const AccordionPanel = styled.div(({ active }) => ({
  display: active ? 'block' : 'none'
}));

export const List = styled(PerfectScrollbar)(({ showMore }) => ({
  position: 'relative',
  maxHeight: showMore ? '28rem' : 'auto',
  a: { textDecoration: 'none' }
}));
